module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/MzdBPr/CoverDesign.jpg?1685327560522",
      "alt": "This image is the cover for the book The Pinch of the Game"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Pinch of the Game\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Being a witch doesn’t mean one can beat the devil forever.")]), _vm._v(" "), _c('p', [_vm._v("Jeffrey Overton, unemployed IT professional turned poker player, pushes his luck once too often and runs afoul of the host of an illegal card club. The man sent to escort Jeffrey to a “meeting” about his supernatural winning streak arrives at Jeffrey’s crappy North Portland apartment, lock-picking tools in hand and a charm to block Jeffrey’s magick.")]), _vm._v(" "), _c('p', [_vm._v("Head muscle for said host, Mike Wells, is a Daisy from Daisyville. He isn’t a witch. What he lacks in magickal talent he makes up for in brawn, so he doesn’t expect the guy he’s after to overpower him. But once Mike renders Jeffrey helpless, he’d rather seduce him than bring him in.")]), _vm._v(" "), _c('p', [_vm._v("Jeffrey and Michael ditch the “meeting” and end up hunting some of the same people they ran from, trying to get Jeffrey back into his own body. And that’s only part of the adventure. The pair travel halfway across the country on the quietest road trip in history and find missing people, empire-building witches, and maybe even the families they’d both thought lost to them.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Charley Descoteaux\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dreamspinner Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0